import { computed } from 'vue'
import store from '@/store/store'
import { Dialer } from '@/types/dialers'

export default function useDialers () {
    const allDialers = computed<Dialer[]>(() => {
        return store.getters['dialers/getAllDialers'] || []
    })
    const dialersWithTypeIVR = computed<Dialer[]>(() => {
        return store.getters['dialers/getAllDialersWithTypeIVR'] || []
    })

    const dialersWithTypeAUTOMATIC = computed<Dialer>(() => {
        return store.getters['dialers/getAllDialersWithTypeAUTOMATIC'] || []
    })

    return {
        allDialers,
        dialersWithTypeAUTOMATIC,
        dialersWithTypeIVR
    }
}
